import request from 'superagent'
import querystring from 'querystring'

export function auth () {
  const query = getQueryStringFromUrl()
  const time = Date.now()
  const isIE = !!document.documentMode
  if (isIE) {
    Object.assign(query, {
      time
    })
  }
  return request
    .get('/api/v1/session/me')
    .query(query)
}

export function logout () {
  const query = getQueryStringFromUrl()
  return request
    .post('/api/v1/session/logout')
    .query(query)
}

function getQueryStringFromUrl () {
  let qs = ''
  if (window.location && window.location.search) {
    qs = window.location.search.slice(1)
  }
  return querystring.parse(qs)
}
